const initialState = {
  errors: {},
  isSubmit: false
}

export default (state = initialState, action) => {
  const { type, payload } = action
  switch (type) {
    case 'ON_SUBMIT_PASSWORD':
      return {
        ...state,
        isSubmit: !state.isSubmit
      }
    case 'ON_SET_ERROR':
      return {
        ...state,
        errors: {
          [payload.name]: payload.value
        }
      }
    case 'ON_CLEAR_PASSWORD':
      return initialState
    default:
      return state
  }
}
